import { ITEMTYPE } from "../gamedata/inventorydata";
import { MultiWait } from "../util/multiwait";
import { DataTable } from "../loaders/stb";
import { StringTable } from "../loaders/stl";

const IDM_STBS: any = {};
IDM_STBS[ITEMTYPE.FACE_ITEM] = "3DDATA/STB/LIST_FACEITEM.STB";
IDM_STBS[ITEMTYPE.HELMET] = "3DDATA/STB/LIST_CAP.STB";
IDM_STBS[ITEMTYPE.ARMOR] = "3DDATA/STB/LIST_BODY.STB";
IDM_STBS[ITEMTYPE.ARMS] = "3DDATA/STB/LIST_ARMS.STB";
IDM_STBS[ITEMTYPE.BOOTS] = "3DDATA/STB/LIST_FOOT.STB";
IDM_STBS[ITEMTYPE.BACK] = "3DDATA/STB/LIST_BACK.STB";
IDM_STBS[ITEMTYPE.JEWEL] = "3DDATA/STB/LIST_JEWEL.STB";
IDM_STBS[ITEMTYPE.WEAPON] = "3DDATA/STB/LIST_WEAPON.STB";
IDM_STBS[ITEMTYPE.SHIELD] = "3DDATA/STB/LIST_SUBWPN.STB";
IDM_STBS[ITEMTYPE.USE] = "3DDATA/STB/LIST_USEITEM.STB";
IDM_STBS[ITEMTYPE.GEM] = "3DDATA/STB/LIST_JEMITEM.STB";
IDM_STBS[ITEMTYPE.NATURAL] = "3DDATA/STB/LIST_NATURAL.STB";
IDM_STBS[ITEMTYPE.QUEST] = "3DDATA/STB/LIST_QUESTITEM.STB";
IDM_STBS[ITEMTYPE.RIDE_PART] = "3DDATA/STB/LIST_PAT.STB";
// IDM_STBS[ITEMTYPE.MOUNT] = '3DDATA/STB/LIST_MOUNT.STB';
const IDM_STLS = {};
IDM_STLS[ITEMTYPE.FACE_ITEM] = "3DDATA/STB/LIST_FACEITEM_S.STL";
IDM_STLS[ITEMTYPE.HELMET] = "3DDATA/STB/LIST_CAP_S.STL";
IDM_STLS[ITEMTYPE.ARMOR] = "3DDATA/STB/LIST_BODY_S.STL";
IDM_STLS[ITEMTYPE.ARMS] = "3DDATA/STB/LIST_ARMS_S.STL";
IDM_STLS[ITEMTYPE.BOOTS] = "3DDATA/STB/LIST_FOOT_S.STL";
IDM_STLS[ITEMTYPE.BACK] = "3DDATA/STB/LIST_BACK_S.STL";
IDM_STLS[ITEMTYPE.JEWEL] = "3DDATA/STB/LIST_JEWEL_S.STL";
IDM_STLS[ITEMTYPE.WEAPON] = "3DDATA/STB/LIST_WEAPON_S.STL";
IDM_STLS[ITEMTYPE.SHIELD] = "3DDATA/STB/LIST_SUBWPN_S.STL";
IDM_STLS[ITEMTYPE.USE] = "3DDATA/STB/LIST_USEITEM_S.STL";
IDM_STLS[ITEMTYPE.GEM] = "3DDATA/STB/LIST_JEMITEM_S.STL";
IDM_STLS[ITEMTYPE.NATURAL] = "3DDATA/STB/LIST_NATURAL_S.STL";
IDM_STLS[ITEMTYPE.QUEST] = "3DDATA/STB/LIST_QUESTITEM_S.STL";
IDM_STLS[ITEMTYPE.RIDE_PART] = "3DDATA/STB/LIST_PAT_S.STL";
// IDM_STLS[ITEMTYPE.MOUNT] = '3DDATA/STB/LIST_MOUNT_S.STL';

export interface EquipStats {
    subtype: number;
    price: number;
    priceRate: number;
    weight: number;
    quality: number;
    level: number;
    reqType1: number;
    reqValue1: number;
    reqType2: number;
    reqValue2: number;
    statType1: number;
    statValue1: number;
    statType2: number;
    statValue2: number;
    defense: number;
    magicResist: number;
    attackDistance: number;
    attackPower: number;
    attackSpeed: number;
    itemGradeId: number;
    itemGrade: number;
    breakId: number;
}

export interface ConsumableStats {
    subtype: number;
    price: number;
    priceRate: number;
    weight: number;
    quality: number;
    priceValue: number;
    useCondition: [number, number];
    useEffect: [number, number];
    cooldownGroup: number;
}

export interface NaturalStats {
    subtype: number;
    price: number;
    priceRate: number;
    weight: number;
    quality: number;
    priceValue: number;
}

export interface PatStats {
    subtype: number;
    price: number;
    priceRate: number;
    weight: number;
    quality: number;
    maxFuel: number;
    fuelConsumption: number;
    speed: number;
    attackDistance: number;
    attackPower: number;
    attackSpeed: number;
}

export interface GemStats {
    price: number;
    priceRate: number;
    statType1: number;
    statValue1: number;
    statType2: number;
    statValue2: number;
    markImage: number;
    attachEffect: number;
}

/**
 * @constructor
 */
export class ItemDataManager {
    data: any;
    strings: any;

    constructor() {
        this.data = {};
        this.strings = {};
    }

    getData(itemType: any, itemNo: any) {
        return this.data[itemType].row(itemNo);
    }

    getName(itemType: any, itemNo: any) {
        let typeData = this.data[itemType];
        let itemKey = typeData.item(itemNo, typeData.columnCount - 1);
        return this.strings[itemType].getByKey(itemKey).text;
    }

    getDescription(itemType: any, itemNo: any) {
        const typeData = this.data[itemType];
        const itemKey = typeData.item(itemNo, typeData.columnCount - 1);
        return this.strings[itemType].getByKey(itemKey).comment;
    }

    // Columns per CEquip (server/OriginalServerFiles/World Server/datatypes.h:423-454),
    // populated by LoadEquip() (World Server/startup.cpp:2240-2362).
    getEquipStats(itemType: any, itemNo: any): EquipStats {
        const row = this.getData(itemType, itemNo);
        const num = (col: number) => Number(row[col]) || 0;
        return {
            subtype: num(4),
            price: num(5),
            priceRate: num(6),
            weight: num(7),
            quality: num(8),
            level: num(13),
            reqType1: num(19),
            reqValue1: num(20),
            reqType2: num(21),
            reqValue2: num(22),
            statType1: num(24),
            statValue1: num(25),
            statType2: num(27),
            statValue2: num(28),
            defense: num(31),
            magicResist: num(32),
            attackDistance: num(33),
            attackPower: num(35),
            attackSpeed: num(36),
            itemGradeId: num(45),
            itemGrade: num(46),
            breakId: num(47),
        };
    }

    // Columns per CUseData (datatypes.h:535-555), LoadConsItem() (startup.cpp:2556-2601).
    getConsumableStats(itemNo: any): ConsumableStats {
        const row = this.getData(ITEMTYPE.USE, itemNo);
        const num = (col: number) => Number(row[col]) || 0;
        return {
            subtype: num(4),
            price: num(5),
            priceRate: num(6),
            weight: num(7),
            quality: num(8),
            priceValue: num(16),
            useCondition: [num(17), num(18)],
            useEffect: [num(19), num(20)],
            cooldownGroup: num(25),
        };
    }

    // Columns per CNaturalData (datatypes.h:475-486), LoadNaturalItem() (startup.cpp:2409-2441).
    getNaturalStats(itemNo: any): NaturalStats {
        const row = this.getData(ITEMTYPE.NATURAL, itemNo);
        const num = (col: number) => Number(row[col]) || 0;
        return {
            subtype: num(4),
            price: num(5),
            priceRate: num(6),
            weight: num(7),
            quality: num(8),
            priceValue: num(15),
        };
    }

    // Columns per CPatData (datatypes.h:489-514), LoadPatItem() (startup.cpp:2443-2492).
    getPatStats(itemNo: any): PatStats {
        const row = this.getData(ITEMTYPE.RIDE_PART, itemNo);
        const num = (col: number) => Number(row[col]) || 0;
        return {
            subtype: num(4),
            price: num(5),
            priceRate: num(6),
            weight: num(7),
            quality: num(8),
            maxFuel: num(31),
            fuelConsumption: num(32),
            speed: num(33),
            attackDistance: num(35),
            attackPower: num(36),
            attackSpeed: num(37),
        };
    }

    // stat1/stat2 columns of LIST_JEMITEM.STB (startup.cpp:2370-2400).
    // price/priceRate at cols 5/6, same convention as every other item family.
    // markImage (col 20) is the SOKETJAM.TSI sprite drawn on the socket;
    // attachEffect (col 21) is the LIST_EFFECT.STB row shown on the weapon.
    getGemStats(gemRowIdx: any): GemStats {
        const row = this.getData(ITEMTYPE.GEM, gemRowIdx);
        const num = (col: number) => Number(row[col]) || 0;
        return {
            price: num(5),
            priceRate: num(6),
            statType1: num(16),
            statValue1: num(17),
            statType2: num(18),
            statValue2: num(19),
            markImage: num(20),
            attachEffect: num(21),
        };
    }

    // "Gem effect position" (LIST_WEAPON col 43, LIST_SUBWPN col 34): the
    // model's ZSC effect point the gem effect attaches to.
    getGemEffectPosition(itemType: any, itemNo: any): number {
        const col = itemType === ITEMTYPE.WEAPON ? 43 : 34;
        return Number(this.getData(itemType, itemNo)[col]) || 0;
    }

    // Sell-to-NPC formula for equip/pat items, ported from pakNPCBuy()
    // (World Server/worldpackets.cpp:3062-3080). Jewel/gem use a separate,
    // simpler formula with no durability (worldpackets.cpp:3155-3187).
    // Consumable/natural (worldpackets.cpp:3082-3153) use a "banded"
    // formula keyed by subtype -- the 11-entry lookup table the original
    // indexes is degenerate (every entry is the same constant), so it
    // collapses to a fixed multiplier of 47 outside the banded subtype
    // range, or (for the banded range) 0 for realistic priceValue (<11).
    getSellValue(itemType: any, itemNo: any, durability: any): number | null {
        const isEquipOrPat =
            (itemType >= ITEMTYPE.FACE_ITEM && itemType <= ITEMTYPE.BACK) ||
            itemType === ITEMTYPE.WEAPON ||
            itemType === ITEMTYPE.SHIELD ||
            itemType === ITEMTYPE.RIDE_PART;
        if (isEquipOrPat) {
            const basePrice =
                itemType === ITEMTYPE.RIDE_PART
                    ? this.getPatStats(itemNo).price
                    : this.getEquipStats(itemType, itemNo).price;
            let price = 7.142857e-5 * 5000;
            price *= basePrice;
            price *= durability + 200;
            price *= 40;
            price *= 200 - 98;
            price *= 1e-6;
            return Math.floor(price);
        }
        if (itemType === ITEMTYPE.JEWEL) {
            const stats = this.getEquipStats(ITEMTYPE.JEWEL, itemNo);
            let price: number = stats.priceRate;
            price *= 47;
            price += 1000;
            price *= stats.price;
            price *= 102;
            price *= 5.555555555555556e-6;
            return Math.floor(price);
        }
        if (itemType === ITEMTYPE.GEM) {
            const stats = this.getGemStats(itemNo);
            let price: number = stats.priceRate;
            price *= 47;
            price += 1000;
            price *= stats.price;
            price *= 102;
            price *= 5.555555555555556e-6;
            return Math.floor(price);
        }
        if (itemType === ITEMTYPE.USE || itemType === ITEMTYPE.NATURAL) {
            const stats =
                itemType === ITEMTYPE.USE
                    ? this.getConsumableStats(itemNo)
                    : this.getNaturalStats(itemNo);
            const multiplier = this._bandedPriceMultiplier(stats.subtype, stats.priceValue);
            let value = multiplier * stats.priceRate;
            value += 1000;
            value *= stats.price;
            value *= 102;
            const price = value * 5.555555555555556e-6;
            return Math.floor(price);
        }
        return null;
    }

    // Buy-from-NPC formula, ported from pakNPCBuy() (worldpackets.cpp:2308-2957).
    // Same item-family split as getSellValue above.
    getBuyPrice(itemType: any, itemNo: any): number | null {
        const isEquip =
            (itemType >= ITEMTYPE.FACE_ITEM && itemType <= ITEMTYPE.BACK) ||
            itemType === ITEMTYPE.WEAPON ||
            itemType === ITEMTYPE.SHIELD;
        if (isEquip) {
            const stats = this.getEquipStats(itemType, itemNo);
            const price = (stats.quality + 50) * stats.price;
            return Math.round((price + 0.5) / 100);
        }
        if (itemType === ITEMTYPE.RIDE_PART) {
            const stats = this.getPatStats(itemNo);
            const price = (stats.quality + 50) * stats.price;
            return Math.round((price + 0.5) / 100);
        }
        if (itemType === ITEMTYPE.JEWEL) {
            const stats = this.getEquipStats(ITEMTYPE.JEWEL, itemNo);
            const price = (stats.priceRate * 47 * 0.001 + 1) * stats.price;
            return Math.round(price + 0.5);
        }
        if (itemType === ITEMTYPE.GEM) {
            const stats = this.getGemStats(itemNo);
            const price = (stats.priceRate * 47 * 0.001 + 1) * stats.price;
            return Math.round(price + 0.5);
        }
        if (itemType === ITEMTYPE.USE || itemType === ITEMTYPE.NATURAL) {
            const stats =
                itemType === ITEMTYPE.USE
                    ? this.getConsumableStats(itemNo)
                    : this.getNaturalStats(itemNo);
            const multiplier = this._bandedPriceMultiplier(stats.subtype, stats.priceValue);
            const price = (multiplier * stats.priceRate * 0.001 + 1) * stats.price;
            return Math.floor(price + 0.5);
        }
        return null;
    }

    // Shared by getBuyPrice/getSellValue's consumable/natural branches.
    // subtype in {311,312} or >=421 uses the "banded" lookup, which is
    // degenerate in the recovered source (every table entry is 50) --
    // see worldpackets.cpp:2634-2657/3128-3144. priceValue>=11 ports the
    // original's unsigned bitwise-NOT edge case bit-for-bit even though
    // real STB data isn't expected to reach it.
    _bandedPriceMultiplier(subtype: number, priceValue: number): number {
        const banded = subtype === 311 || subtype === 312 || subtype >= 421;
        if (!banded) return 47;
        if (priceValue >= 11) return ((0xffffffff - priceValue) >>> 0) - 50;
        return 0;
    }

    /**
     * Load helper so the ItemDataManager can be controlled by the GDM.
     *
     * @param path Ignores
     * @param callback
     */
    static load(path: any, callback: any) {
        const waitAll = new MultiWait();
        const mgr = new ItemDataManager();
        for (let i in IDM_STBS) {
            if (IDM_STBS.hasOwnProperty(i)) {
                DataTable.load(
                    IDM_STBS[i],
                    function (stbIdx: any, waitCb: any, stbData: any) {
                        mgr.data[stbIdx] = stbData;
                        waitCb();
                    }.bind(this, i, waitAll.one())
                );
            }
        }
        for (let i in IDM_STLS) {
            if (IDM_STLS.hasOwnProperty(i)) {
                StringTable.load(
                    IDM_STLS[i],
                    function (stlIdx: any, waitCb: any, stlData: any) {
                        mgr.strings[stlIdx] = stlData;
                        waitCb();
                    }.bind(this, i, waitAll.one())
                );
            }
        }
        waitAll.wait(() => {
            callback(mgr);
        });
    }
}
